import { useEffect } from 'react'
import { unlockFeedbackAudio } from '../../services/feedbackSoundService'

/**
 * Browsers block audio until the user interacts with the page.
 * This component unlocks the audio context on first click/keydown.
 */
export default function FeedbackSoundGate() {
  useEffect(() => {
    const unlock = () => {
      unlockFeedbackAudio()
      window.removeEventListener('pointerdown', unlock)
      window.removeEventListener('keydown', unlock)
    }

    window.addEventListener('pointerdown', unlock, { once: true, passive: true })
    window.addEventListener('keydown', unlock, { once: true })

    return () => {
      window.removeEventListener('pointerdown', unlock)
      window.removeEventListener('keydown', unlock)
    }
  }, [])

  return null
}
